export default __webpack_public_path__ + "static/media/twitter.46c236fd.jpeg";